import { Controller } from 'libraries/front-end-core/core/Router'
import { combineLatest, merge } from 'rxjs'
import { takeUntil, skip, debounceTime } from 'rxjs/operators'
import { UserInteraction, RenderNotification, MouseWheel } from 'libraries/front-end-core/services/WindowService'
import { scrollTo } from 'libraries/front-end-core/helpers/document'
import getUrl from 'libraries/front-end-core/core/url'
import { LEGISLATION } from 'constants/controllers'
import { Media } from 'services/WindowService'
import Header from './Header'
import Main from './Main'

export default new Controller({
  name: LEGISLATION,
  route: 'legislation/*path(/edit/:editingId)',
  controller (
    Router,
    {
      url,
      scrollMain,
      pageView,
      pageData,
      params: { path = null, editingId = null },
      previousPageId,
      query
    },
    render
  ) {
    const [act] = (path && path.split(':')) || []
    const pageId = getUrl(LEGISLATION, { path: act, editingId })

    render(
      { Header, Main },
      { act: path, scrollMain, editingId, highlight: `#${url}` },
      {
        act: path,
        pageId,
        searchType: 'legislation',
        className: 'legislation'
      }
    )

    if (scrollMain !== null || path) {
      combineLatest(
        [Media.Mobile,
          RenderNotification.pipe(debounceTime(5))]
      )
        .pipe(takeUntil(merge(UserInteraction, MouseWheel), skip(1)))
        .subscribe(([isMobile]) => {
          if (scrollMain) {
            scrollTo({ pageId, id: scrollMain, useWindowScrollTo: isMobile })
          } else if (path && path.split(':::::').length !== 2) { // disable scroll when at top level
            scrollTo({ pageId, id: getUrl(LEGISLATION, { path }), useWindowScrollTo: isMobile })
          }
        })
    }

    return pageId
  }
})
